import gql from 'graphql-tag'

export default gql`
query cmsContent($url_key: String!) {
    cmsContent(url_key: $url_key) {
        title
        content
        meta_title
        meta_keywords
        meta_description
    }
}
`
